if (!customElements.get('hotspot-items')) {

class HotspotItems extends HTMLElement {

  connectedCallback() {

    this.items = this.querySelectorAll('.hotspot');

    if (!this.items.length) return;

    if (window.matchMedia('(hover: none)').matches) {

      this.items.forEach((item) => {

        item.addEventListener('click', (e) => {

          e.stopPropagation();

          this.items.forEach((other) => {
            if (other !== item) {
              other.classList.remove('active');
            }
          });

          item.classList.toggle('active');

          this.positionAllHotspots();

        });

      });

      this.onDocumentClick = () => {
        this.items.forEach((item) => item.classList.remove('active'));
      };

      document.addEventListener('click', this.onDocumentClick);

    }

    this.onResize =
      typeof $s !== 'undefined' && $s.throttle
        ? $s.throttle(() => this.positionAllHotspots(), 100)
        : () => this.positionAllHotspots();

    window.addEventListener('resize', this.onResize);

    if (typeof ResizeObserver !== 'undefined') {
      this.resizeObserver = new ResizeObserver(() => this.positionAllHotspots());
      this.resizeObserver.observe(this);
    }

    requestAnimationFrame(() => {
      requestAnimationFrame(() => this.positionAllHotspots());
    });

  }

  disconnectedCallback() {

    window.removeEventListener('resize', this.onResize);

    if (this.onDocumentClick) {
      document.removeEventListener('click', this.onDocumentClick);
    }

    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
      this.resizeObserver = null;
    }

  }

  positionAllHotspots() {

    this.items.forEach((item) => {
      this.adjustHotspotPosition(item);
    });

  }

  adjustHotspotPosition(item) {

    const content = item.querySelector('.hotspot-content');
    if (!content) return;

    content.style.setProperty('--hotspot-shift-x', '0px');
    content.style.setProperty('--hotspot-shift-y', '0px');

    const containerRect = this.getBoundingClientRect();
    const contentRect = content.getBoundingClientRect();

    let shiftX = 0;
    let shiftY = 0;

    if (contentRect.right > containerRect.right) {
      shiftX = containerRect.right - contentRect.right - 10;
    } else if (contentRect.left < containerRect.left) {
      shiftX = containerRect.left - contentRect.left + 10;
    }

    if (contentRect.bottom > containerRect.bottom) {
      const overflow = contentRect.bottom - containerRect.bottom;
      shiftY = -(overflow + 30);
    } else if (contentRect.top < containerRect.top) {
      const overflow = containerRect.top - contentRect.top;
      shiftY = overflow + 10;
    }

    content.style.setProperty('--hotspot-shift-x', `${shiftX}px`);
    content.style.setProperty('--hotspot-shift-y', `${shiftY}px`);
  }

}

customElements.define('hotspot-items', HotspotItems);

}